export enum m3ItemsContentEnum{
    NaturalFabrics = 'Natural Fabrics',
    ManufacturedFabrics='Manufactured Fabrics'
  }